import React, {memo} from "react";
import { LockIcon } from "../../../../Access/common/LockIcon";
import FormatNumber from "../../../../FormatNumber";

function ProfitPct(props) {
    const { record, hideInventoryCosting } = props;

    if (hideInventoryCosting)
        return <LockIcon className="grey" />;

    if (record.base_profit_pct)
        return <FormatNumber amount={record.base_profit_pct} />;
    return '-';
}

export default memo(ProfitPct);
